import React, { useState } from 'react';
import styled from 'styled-components';
import { Stripe, StripeCardElement, StripeElements } from '@stripe/stripe-js';
import { CardElement } from '@stripe/react-stripe-js';

import { Modal } from 'vendor-deprecated/Modal';
import { useTranslationText } from 'locale';
import { useAppSetting } from 'helpers/useAppSetting';
import { AppConst } from 'helpers';

export const ModalWrapper = styled.div``;
export const AlertModalWrapper = styled.div``;
export const ContentWrapper = styled.div``;
export const AddUserWrapper = styled.div``;

interface Props {
  stripe: Stripe | null;
  elements: StripeElements | null;
  open: boolean;
  onClose: () => void;
}

const Wrapper = styled.div`
  form {
    width: 30vw;
    align-self: center;
    box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1), 0px 2px 5px 0px rgba(50, 50, 93, 0.1),
      0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
    border-radius: 7px;
    padding: 40px;
  }
  input {
    border-radius: 6px;
    margin-bottom: 6px;
    padding: 12px;
    border: 1px solid rgba(50, 50, 93, 0.1);
    max-height: 44px;
    font-size: 16px;
    width: 100%;
    background: white;
    box-sizing: border-box;
  }
`;

export const CheckoutModal = React.memo((props: Props) => {
  const { translation } = useTranslationText();
  const { appTheme, appLayout } = useAppSetting();
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [processing, setProcessing] = useState(false);
  const [disabled, setDisabled] = useState(true);

  const { elements, stripe } = props;

  const cardStyle = {
    hidePostalCode: true,
    style: {
      base: {
        color: '#32325d',
        fontFamily: 'Arial, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#32325d',
        },
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755as',
      },
    },
  };

  const handleChange = async (event: any) => {
    setDisabled(event.empty);
    setError(event.error ? event.error.message : '');
  };

  const handleSubmit = async (ev: any) => {
    ev.preventDefault();
    if (stripe && elements && elements.getElement(CardElement)) {
      const card: StripeCardElement = elements.getElement(CardElement) as StripeCardElement;
      setProcessing(true);
      const { error, paymentMethod } = await stripe.createPaymentMethod({
        type: 'card',
        card,
      });

      setProcessing(true);
      setSucceeded(false);
    }
  };

  return (
    <Modal
      title={translation('home.category.header')}
      open={props.open}
      headerBackground={appTheme.sidebar.bg}
      height={appLayout.isMobile ? '100vh' : 'auto'}
      zIndex={AppConst.zIndex.header + 60}
      onClose={() => {
        props.onClose();
      }}
      closeOnBackDropClick
    >
      <Wrapper>
        <form id="payment-form" onSubmit={handleSubmit}>
          <CardElement id="card-element" options={cardStyle} onChange={handleChange} />
          <button disabled={processing || disabled || succeeded} id="submit">
            <span id="button-text">{processing ? <div className="spinner" id="spinner"></div> : 'Pay now'}</span>
          </button>

          {error && <div>{error}</div>}

          {succeeded && <p>Payment succeeded</p>}
        </form>
      </Wrapper>
    </Modal>
  );
});
